import FooterPublic from '~/components/organisms/FooterPublic/FooterPublic';
import HeaderPublic from '~/components/organisms/HeaderPublic/HeaderPublic';
import { StyledContainer, StyledLayout } from '~/pages/HomePage/styled';

import CreateQrCodeSteps from './components/create-qr-code-steps/CreateQrCodeSteps';
import QrCodesInMenus from './components/qr-codes-in-menus/QrCodesInMenus';
import RestaurantMenu from './components/restaurant-menu/RestaurantMenu';

export default function QrsOnDetail() {
  return (
    <StyledLayout>
      <HeaderPublic />
      <StyledContainer className="customContainer">
        {/*TODO*/}
        {/*Rename it to QrCodeContentTemplate and use it as template*/}
        <QrCodesInMenus />
        <CreateQrCodeSteps />
        <RestaurantMenu />
      </StyledContainer>
      <FooterPublic />
    </StyledLayout>
  );
}
